import { CustomerCareInventoryWindowTitleSelector } from '../../../reducers/selectors/customer.selectors';
export var INVENTORY_STATE_NAME = 'index.customercare.customer.inventory';
export default (function ($stateProvider) {
  $stateProvider.state(INVENTORY_STATE_NAME, {
    template: '<inventory></inventory>',
    url: '/inventory/:serialNumber/:inventoryId',
    params: {
      inventoryId: '',
      serialNumber: ''
    },
    data: {
      windowTitle: CustomerCareInventoryWindowTitleSelector
    }
  });
});